import { render, staticRenderFns } from "./SelectLanguage.vue?vue&type=template&id=24a2ef6e&scoped=true"
import script from "./SelectLanguage.vue?vue&type=script&lang=ts"
export * from "./SelectLanguage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a2ef6e",
  null
  
)

export default component.exports